import { htmlNew, htmlTagged } from '../fun-js-lib/html'
import { hourHint, temperatureHint } from './hint'
import { isValidHour } from './shiftTimes'

export function initValidateTemperature () {
  getTemperatureInputs().forEach(input => {
    input.addEventListener('input', validate)
  })
  validate()
}

function validate () {
  let isHintSet = false
  getTemperatureInputs().forEach(input => {
    let valid = false
    let hint = ''
    if (input.name === 'timeT[]') {
      valid = isValidOrEmptyHour(input.value)
      hint = hourHint
    } else {
      valid = isValidOrEmptyTemperature(input.value)
      hint = temperatureHint
    }
    input.classList.toggle('is-invalid', !valid)
    if (!valid && !isHintSet) {
      setErrorHint(hint)
      isHintSet = true
    }
  })
  if (!isHintSet) {
    unsetErrorHint()
  }
}

/**
 * Returns true iff some temperature fields is filled
 * but incorrect
 */
export const isTemperatureFieldsFilledIncorrectly = () =>
  getTemperatureInputs().some(input =>
    input.name === 'timeT[]' ?
      !isValidOrEmptyHour(input.value) :
      !isValidOrEmptyTemperature(input.value))

/**
 * @param {string} value 
 */
const isValidOrEmptyHour = value =>
  isValidHour(value) || value === ''

/**
 * @param {string} value 
 */
const isValidOrEmptyTemperature = value =>
  isValidTemperature(value) || value === ''

/**
 * @param {string} str 
 */
function isValidTemperature (str) {
  return /^-?\d{1,3}\.?\d?$/.test(str) && +str < 101 && +str > -101 && !/^0\d+$/.test(str)
}

/**
 * @param {string} hint 
 */
function setErrorHint (hint) {
  unsetErrorHint()
  let h5 = htmlNew('h5')
  h5.classList.add('text-center')
  let small = htmlNew('small')
  small.classList.add('text-danger')
  small.innerHTML = hint
  h5.appendChild(small)
  container()
    .prepend(h5)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h5')
    .forEach(small => small.remove())
}

export function getTemperatureInputs () {
  return htmlTagged(container(), 'input')
}

function container () {
  return document.getElementById('temperatureContainer')
}